module.exports = function getResource(label, vars = []) {
    let resources = {
        kilometer: 'kilometer',
        mile: 'mile',
        away: 'away',
        closed: 'Closed',
        storeClosed: 'Store Closed',
        openUntil: `Open until ${vars[0]}`,
        getDirections: 'Get directions'
    };

    return resources[label];
};
